import { Icon } from '../icon/icon.spark';
import type { FieldErrorProps } from './types';

/**
 * The inline validation message shown beneath a spark form control.
 *
 * The Polaris and Wix controls take an `error` prop and render the message themselves, so there is
 * nothing for those themes to share. BigCommerce has its own in `field-error.bigcommerce.tsx`.
 */
export function FieldError({ id, children }: FieldErrorProps) {
  return (
    <span id={id} className="flex items-center gap-0.5 text-spark-text-danger">
      <Icon name="xCircle" />
      <p className="whitespace-pre-line text-xs">{children}</p>
    </span>
  );
}
